/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type PaymentTypeSelect_paymentType$ref: FragmentReference;
declare export opaque type PaymentTypeSelect_paymentType$fragmentType: PaymentTypeSelect_paymentType$ref;
export type PaymentTypeSelect_paymentType = {
  +id: string,
  +name: string,
};
export type PaymentTypeSelect_paymentType$data = PaymentTypeSelect_paymentType;
export type PaymentTypeSelect_paymentType$key = {
  +$data?: PaymentTypeSelect_paymentType$data,
  +$fragmentRefs: PaymentTypeSelect_paymentType$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PaymentTypeSelect_paymentType",
  "type": "PaymentType",
  "metadata": {
    "mask": false
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'fd3c80e9bf2246c1f81f0d4244dffeb0';
module.exports = node;
